<template>
 <v-container>
 <v-card style="border-radius: 8px;">
     <v-container>
         <v-layout>
             <v-flex xs3>
                    <v-card-title>
                        <h2 class="font-weight-regular">Message to broadcast</h2>
                    </v-card-title>
             </v-flex>             
             <v-flex xs4>
                <v-select
                    item-text="name"  
                    item-value="id"                   
                    :items="cMessages"
                    label="Select message template"
                    v-model="docId"
                    
                ></v-select>
             </v-flex>
         </v-layout>
        <v-layout>
             <v-flex xs3>
                    <v-card-title>
                        <h2 class="font-weight-regular">Message type</h2>
                    </v-card-title>
             </v-flex>             
             <v-flex xs4>
                <v-select
                    item-text="tag" 
                    :items="cMessageTags"
                    label="Select message type"
                    v-model="messageTag"                    
                    return-object
                ></v-select>
             </v-flex>
             <v-flex  color="grey--text" xs5>
                    <div>{{messageTag.description}}</div>
            </v-flex>
         </v-layout>
        <!-- <v-layout>
             <v-flex xs3>
                    <v-card-title>
                        <h2 class="font-weight-regular">Broadcast to label</h2>
                    </v-card-title>
             </v-flex>             
             <v-flex xs4>
                <v-select
                    class="ma-0 pa-0"
                    :items="labels"
                    label="Select label"
                    v-model="label"                    
                ></v-select>
             </v-flex>
         </v-layout> -->
                 <v-layout>
             <v-flex xs3>
                    <v-card-title>
                        <h2 class="font-weight-regular">Notification type</h2>
                    </v-card-title>
             </v-flex>             
             <v-flex xs4>
                <v-radio-group v-model="notifyType">
                    <v-radio
                        label="Notify with sound"
                        value="REGULAR"
                    ></v-radio>
                     <v-radio
                        label="Notify without sound"
                        value="SILENT_PUSH"
                    ></v-radio>
                    <v-radio
                        label="Don't notify"
                        value="NO_PUSH"
                    ></v-radio>
                </v-radio-group>
             </v-flex>
         </v-layout>
                 <v-layout>
             <v-flex xs3>
                    <v-card-title>
                        <h2 class="font-weight-regular">Broadcast type</h2>
                    </v-card-title>
             </v-flex>             
             <v-flex xs4>
                <v-radio-group v-model="schedule">
                    <v-radio
                        label="Broadcast now"
                        value="no"
                    ></v-radio>
                     <v-radio
                        label="Schedule broadcast"
                        value="yes"
                    ></v-radio>
                </v-radio-group>
             </v-flex>
             <v-flex xs3 class="mt-2 ml-5" v-if="schedule == 'no'">
                <v-card class="mt-4 blue lighten-5" style="border-radius: 8px;">
                    <v-btn  @click="broadcastmessage" class="mt-2" block flat >Broadcast</v-btn>
                </v-card>
             </v-flex>
         </v-layout>
        <v-layout v-if="schedule == 'yes'">
             <v-flex xs3>
                    <v-card-title>
                        <h2 class="font-weight-regular">Scheduler</h2>
                    </v-card-title>
             </v-flex>             
             <v-flex xs4>
                <v-menu
                    ref="menudate"
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="date"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="date"
                    label="Pick date"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn flat color="primary" @click="$refs.menudate.save(date)">OK</v-btn>
                    </v-date-picker>
                </v-menu>
                <v-menu
                    ref="menutime"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="time"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="time"
                    label="Pick time"
                    prepend-icon="access_time"
                    readonly
                    v-on="on"
                    ></v-text-field>
                    </template>
                    <v-time-picker
                    v-if="menu2"
                    v-model="time"
                    full-width
                    >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="menu2 = false">Cancel</v-btn>
                    <v-btn flat color="primary" @click="$refs.menutime.save(time)">OK</v-btn>
                    </v-time-picker>
                </v-menu>
                <v-select
                    v-model="timezone"
                    label="Pick timezone"
                    prepend-icon="language"
                    :items="timezoneslist"
                    item-text="offset" 
                ></v-select>
             </v-flex>
             <v-flex xs3 class="mt-5 ml-5">
                <v-card class="mt-4 blue lighten-5" style="border-radius: 8px;">
                    <v-btn @click="schedulebroadcastmessage" class="mt-2" block flat >Broadcast</v-btn>
                </v-card>
             </v-flex>
         </v-layout>         
    </v-container>
 </v-card>
</v-container>    
</template>

<script>
import {db} from '@/plugins/firebase.js'; 
import {timeZones} from '@/plugins/timezones.js'; 
Date.prototype.toIsoString = function() {
    var tzo = -this.getTimezoneOffset(),
        dif = tzo >= 0 ? '+' : '-',
        pad = function(num) {
            var norm = Math.floor(Math.abs(num));
            return (norm < 10 ? '0' : '') + norm;
        };
    return this.getFullYear() +
        '-' + pad(this.getMonth() + 1) +
        '-' + pad(this.getDate()) +
        'T' + pad(this.getHours()) +
        ':' + pad(this.getMinutes()) +
        ':' + pad(this.getSeconds()) +
        dif + pad(tzo / 60) +
        ':' + pad(tzo % 60);
}
export default {
    data(){
        return{
            docId:null,
            messageTag:{"tag":"NON_PROMOTIONAL_SUBSCRIPTION","description":"The non_promotional_subscription tag can be used to send non-promotional messages under the News, Productivity, and Personal Trackers categories described in the Messenger Platform's subscription messaging policy. You can apply for access to use this tag under the Page Settings > Messenger Platform. Use Cases: News. Productivity. Personal Trackers."},
            label:null,
            notifyType:"REGULAR",
            schedule:"no",
            errornote:"error message",                  
            date: new Date().toIsoString().substr(0, 10),
            menu: false,
            modal: false,
            menu2: false,
            time: null,
            modal2: false,
            timezoneslist:timeZones,
            timezone:null
        }
    },
    computed:{
        cMessages(){
            if(this.$store.state.bTemplateNames.length > 0)
            {
                return this.$store.state.bTemplateNames
            }
            else {
                return []
            }
            
        },
        cMessageTags(){
            return this.$store.state.bmessageTags
        }
    },
    methods:{
        broadcastmessage(){
            let messages = null
            let ntype = this.notifyType
            let mtag = this.messageTag.tag
            console.log(this.docId)
            console.log(this.messageTag)
            console.log(this.notifyType)
            console.log(this.schedule)
            let pageid = this.$store.state.selectedPage
            let accessToken = this.$store.state.pageDetails.accessToken
            let messageId = null
            var getbMessage = db.doc('pages/'+pageid+'/broadcast/'+this.docId).get()
                .then(doc => {
                    if (!doc.exists) {
                    console.log('No such document!');
                    } else {
                        messages = doc.data().messages
                        console.log(messages)
                            let counterLength = messages.length
                            let i=0
                            sendmsg();
                            function sendmsg(){
                            FB.api(
                                "/"+pageid+"/message_creatives?access_token=" +accessToken,
                                'POST',
                                {"messages": [messages[i].message]},
                                function (response) {
                                    console.log(response)
                                    let msgid = response.message_creative_id
                                    // FB.api(
                                    //     "/"+pageid+"/broadcast_messages?access_token=" +accessToken,
                                    //     'POST',
                                    //     {    
                                    //         "message_creative_id": msgid,
                                    //         "notification_type": ntype,
                                    //         "messaging_type": "MESSAGE_TAG",
                                    //         "tag": mtag
                                    //     },
                                    //     function (response) {
                                    //         console.log(response)
                                    // });
                                    FB.api(
                                        "/"+pageid+"/messages?access_token=" +accessToken,
                                        'POST',
                                        {    
                                            "recipient": { 
                                                    "id": "1935905633181102"
                                                },
                                            "messaging_type": "MESSAGE_TAG",
                                            "tag": "NON_PROMOTIONAL_SUBSCRIPTION",
                                            "message": {
                                                    "text": "Travel started. test message"
                                                },
                                        },
                                        function (response) {
                                            console.log(response)
                                    });
                            });
                            i++
                            if(i < counterLength){
                               setTimeout(sendmsg,1000);
                            }
                            }
                    }
                })
                .catch(err => {
                    console.log('Error getting document', err);
                });   
        },
        schedulebroadcastmessage(){
            let messages = null
            let ntype = this.notifyType
            let mtag = this.messageTag.tag
            console.log(this.docId)
            console.log(this.messageTag)
            console.log(this.notifyType)
            console.log(this.schedule)
            let pageid = this.$store.state.selectedPage
            let accessToken = this.$store.state.pageDetails.accessToken
            let messageId = null
            let scheduleTime = this.date+this.time+'+'+this.timezone.substr(4, 5)
            console.log(scheduleTime)
            var getbMessage = db.doc('pages/'+pageid+'/broadcast/'+this.docId).get()
                .then(doc => {
                    if (!doc.exists) {
                    console.log('No such document!');
                    } else {
                        messages = doc.data().messages
                        console.log(messages)
                            let counterLength = messages.length
                            let i=0
                            sendmsg();
                            function sendmsg(){
                            FB.api(
                                "/"+pageid+"/message_creatives?access_token=" +accessToken,
                                'POST',
                                {"messages": [messages[i].message]},
                                function (response) {
                                    console.log(response)
                                    let msgid = response.message_creative_id
                                    // FB.api(
                                    //     "/"+pageid+"/broadcast_messages?access_token=" +accessToken,
                                    //     'POST',
                                    //     {    
                                    //         "message_creative_id": msgid,
                                    //         "schedule_time": scheduleTime,
                                    //         "notification_type": ntype,
                                    //         "messaging_type": "MESSAGE_TAG",
                                    //         "tag": mtag
                                    //     },
                                    //     function (response) {
                                    //         console.log(response)
                                    // });
                                    FB.api(
                                        "/"+pageid+"/messages?access_token=" +accessToken,
                                        'POST',
                                        {    
                                            "recipient": { 
                                                    "id": "1935905633181102"
                                                },
                                            "messaging_type": "MESSAGE_TAG",
                                            "tag": "TRANSPORTATION_UPDATE",
                                            "message": {
                                                    "text": "Travel started. test message"
                                                },
                                        },
                                        function (response) {
                                            console.log(response)
                                    });
                            });
                            i++
                            if(i < counterLength){
                               setTimeout(sendmsg,1000);
                            }
                            }
                    }
                })
                .catch(err => {
                    console.log('Error getting document', err);
                });
        }
    }
}
</script>
